module.exports = __webpack_public_path__ + "img/na-adjusters-screen.f503db78.png";